import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardTitle, Collapse, Table } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { v1 as uuidv1 } from 'uuid';

import { appendModel, modifyModelAttr } from '../../../../features/site/siteSlice'
import { allowedSiteTypes, generatePassword } from '../../../utils/common'
import { checkUserExists, deleteUser, getUsers, postUser, updateUser, USER_FORM } from '../../../utils/Users'
import usePrevious from '../../../hooks/UsePrevious';
import setting from '../../../utils/Settings';

const INITIAL_STATE = {
    toggle: false,
    disableButton: false
}

function BrandUsers({title}){
    const dispatch = useDispatch()

    const model = useSelector(state => state.site.model)
    const isAdmin = useSelector(state => state.session.isAdmin)

    const prevModel = usePrevious(model)

    const [state, setState] = useState(INITIAL_STATE)

    useEffect(() => {
        if(prevModel?.orgForm?.siteId !== model.orgForm?.siteId && model.orgForm?.siteId && (isAdmin || 
            allowedSiteTypes.includes(model?.userSite?.type))) {
            getUsers(model.orgForm.siteId).then(({response, error}) => {
                if(response){
                    dispatch(appendModel({
                        users: response.users || []
                    }))
                } else {
                    dispatch(appendModel({
                        users: []
                    }))
                }
            })
        }
        return () => {
            dispatch(appendModel({
                users: []
            }))
        }
    }, [prevModel?.orgForm?.siteId, model.orgForm?.siteId])

    const onChange = (bool=false) => (e) => {
        dispatch(modifyModelAttr({
            key: "userForm",
            body: {
                ...model.userForm,
                [e.target.name]: bool ? !model.userForm[e.target.name] : e.target.value
            }
        }))
    }

    const initUser = async() => {
        const user = {
            ...USER_FORM,
            enableBillingEmails: false,
            enableSiteAlerts: false,
            password: generatePassword(12),
            siteId: model.orgForm.siteId
        }        

        dispatch(appendModel({userForm: user}))

        setState(prev => ({
            ...prev, 
            toggle: true
        }))
    }

    const addUser = async() => {
        if(isAdmin){
            await setState(prev => ({
                ...prev,
                disableButton: true
            }))

            const {response, error} = await checkUserExists(model.userForm.email)
            if(!response || response.exists){
                toast.error("User email is already taken", {containerId: "defaultToastContainer"})
            } else {
                const uForm = {...model.userForm}
                const { response, error } = await postUser(uForm)

                if(response){

                    uForm.userId = response.result.userId
                    
                    await dispatch(appendModel({
                        users: [...model.users, uForm],
                        userForm: USER_FORM
                    }))
                    
                    
                    await setState(prev => ({
                        ...prev,
                        toggle: false,
                        disableButton: false
                    }))
                    
                    toast.success("User added successfully", {containerId: "defaultToastContainer"})
                } else {
                    toast.success("Something went wrong", {containerId: "defaultToastContainer"})
                }
            }
        } else {
            toast.error("You do not have permissions to add a user", {containerId: "defaultToastContainer"})
        }
    }

    const saveUser = (u, idx) => async(e) => {
        if(isAdmin){
            let user = {...u}
            let users = [...model.users]
            user[e.target.name] = user[e.target.name] === undefined ? true : !user[e.target.name]

            users[idx] = user
            dispatch(appendModel({
                users
            }))

            await updateUser(null, user)

        } else {
            toast.error("You do not have permissions to update a user", {containerId: "defaultToastContainer"})
        }
    }

    const onDeleteUser = async(u, idx) => {
        if(!window.confirm('Are you sure to delete '+u.email)) {
            return
        }
        
        let users = [...model.users]
        
        users.splice(idx, 1)

        dispatch(appendModel({
            users
        }))

        const { response } = await deleteUser(u.userId)

        if(response){
            toast.success("Deleted successfully", {containerId: "defaultToastContainer"})
        } else {
            toast.error("User was not deleted", {containerId: "defaultToastContainer"})
        }
    }

    const { userTitle, toggle, disableButton } = state

    const { userForm, users } = model

    const isAllowed = isAdmin

    return <>
        <h3>{setting.topLevelName} Users</h3><br />
        <div className="d-flex justify-content-end mb-3">
            <div className="btn-group">
                {isAllowed && <button className="btn btn-lg btn-primary" onClick={() => initUser()}>
                    <i class="fas fa-save"></i> Add User
                </button>}
            </div>
        </div>

        <Collapse isOpen={toggle}>
            <Card>
                <CardBody>
                    <CardTitle tag="h4">
                        Add User
                    </CardTitle>

                    <form class="form">
                        <div class="form-group">
                            <input type="text" class="form-control" name="given_name" value={userForm.given_name} placeholder="First Name" onChange={onChange()} />
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" name="family_name" value={userForm.family_name} placeholder="Last Name" onChange={onChange()} />
                        </div>
                        <div class="form-group">
                            <input type="email" class="form-control" name="email" value={userForm.email} placeholder="Email" onChange={onChange()} />
                        </div>
                        {isAdmin && <div class="form-group">
                            <input type="text" disabled={true} class="form-control" name="password" value={userForm.password} placeholder="Password"/>
                        </div>}
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" name="enableSiteAlerts" id={"toggleSiteAlerts"} onChange={onChange(true)} checked={userForm.enableSiteAlerts ? "checked" : "" } />
                                <label class="custom-control-label" htmlFor={"toggleSiteAlerts" }>Toggle Site Alerts</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" name="enableBillingEmails" id={"toggleBillingEmail" } onChange={onChange(true)} checked={userForm.enableBillingEmails ? "checked" : ""} />
                                <label class="custom-control-label" htmlFor={"toggleBillingEmail" }>Toggle Billing Emails</label>
                            </div>
                        </div>
                        <div className="btn-group">
                            <button class="btn btn-primary" type="button" onClick={() => addUser()} disabled={disableButton}>Save</button>
                            <button class="btn btn-outline-primary" type="button" onClick={() => setState(prev => ({...prev, toggle: false}))}>Close</button>
                        </div>
                    </form>
                </CardBody>
            </Card>
        </Collapse>
        <Table responsive>
            <thead>
                <tr>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    {(isAdmin) && <th></th>}
                    {isAllowed && <th></th>}
                </tr>
            </thead>
            <tbody>
                {users.map((u, key) => <tr>
                    <td>{u.given_name}</td>
                    <td>{u.family_name}</td>
                    <td>{u.email}</td>
                    {(isAdmin) && <>
                        <td>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" name="enableSiteAlerts" id={"toggleSiteAlerts"+key} checked={u.enableSiteAlerts ? "checked" : "" } onChange={saveUser(u, key)} />
                                <label class="custom-control-label" htmlFor={"toggleSiteAlerts"+key }>Toggle Site Alerts</label>
                            </div>
                        </td>
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" name="enableBillingEmails" id={"toggleBillingEmail" + key } onChange={saveUser(u, key)} checked={u.enableBillingEmails ? "checked" : ""} />
                                <label class="custom-control-label" htmlFor={"toggleBillingEmail"+key }>Toggle Billing Emails</label>
                            </div>
                        </div>
                    </>}
                    {isAllowed && 
                        <td>
                            <div className="btn-group">
                                <button className="btn btn-danger btn-sm" onClick={() => onDeleteUser(u, key)}>
                                    <i className="fas fa-trash"></i> Delete
                                </button>
                            </div>
                        </td>}
                </tr>)}
            </tbody>
        </Table>
            
    </>
}

export default BrandUsers